module.exports = __webpack_public_path__ + "images/category_lp/common/icon-toku@2x_0bd99c857d7d82ea6d7bfe00600809b3.png";